export enum EmergencyCallType {
  EMERGENCY = 'emergency',
  EMERGENCY_CALLBACK = 'emergencyCallback',
}
